import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import toast, { Toaster } from "react-hot-toast";
import ModalDelete from "../../common/ModelDelete";
import { EditButton, DeletButton } from "../../common/Button";
import { Button, Nav } from "react-bootstrap";
import { IDS, RoleId } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import StaffForm from "./StaffForm";

// Role ids match ayurlife-node/helper/fix_ids.js
export const STAFF_ROLES = [
  { id: RoleId.Customer, label: "Crown" },
  { id: 3, label: "BDMs" },
  { id: 4, label: "General Manager" },
  { id: 5, label: "Manager" },
  { id: 6, label: "Supervisor" },
  { id: 7, label: "Coordinator" },
];

const PER_PAGE = 10;

const StaffTabs = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
  } = useContext(Context);

  const [role, setRole] = useState(STAFF_ROLES[0]);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [editId, setEditId] = useState(0);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const fetchData = async () => {
    const response = await getData(
      `/admin/employee-management/crown?page=${page}&per_page=${PER_PAGE}&term=${encodeURIComponent(
        search,
      )}&employee_id=${encodeURIComponent(employeeId)}&role_id=${role.id}`,
    );
    setData(response?.data?.data || []);
    setTotalPages(response?.data?.total_pages || 1);
  };

  useEffect(() => {
    fetchData();
  }, [role, page, refresh, showAdd, editId]);

  const selectRole = (r) => {
    setRole(r);
    setPage(1);
    setSearch("");
    setEmployeeId("");
  };

  const changeStatus = async (id) => {
    await editStatusData(`/admin/employee-management/crown/${id}`);
    setRefresh((n) => n + 1);
  };

  const confirmDelete = async () => {
    const target = deleteTarget;
    setDeleteTarget(null);
    if (!target) return;
    await deleteData(`/admin/employee-management/crown/${target.id}`);
    ErrorNotify(target.name);
    setRefresh((n) => n + 1);
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Staff"} link={"/staff"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio mt-3">
                <Nav variant="tabs" activeKey={role.id} className="mb-3">
                  {STAFF_ROLES.map((r) => (
                    <Nav.Item key={r.id}>
                      <Nav.Link eventKey={r.id} onClick={() => selectRole(r)}>
                        {r.label}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                <div className="row align-items-end">
                  <div className="col-xl-3 col-lg-4 col-md-6 mb-2">
                    {isAllow.includes(IDS.User.Add) && (
                      <Link
                        type="button"
                        className="btn btn-add pe-3"
                        onClick={() => setShowAdd(true)}
                      >
                        <img src={plus} className="plus me-2 ms-0" alt="" />
                        Add {role.label}
                      </Link>
                    )}
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 mb-2">
                    <label className="form-label">Employee ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={employeeId}
                      placeholder="Search Employee ID"
                      onChange={(e) => setEmployeeId(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 mb-2">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={search}
                      placeholder="Search Name"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 mb-2 d-flex gap-3">
                    <Button
                      type="button"
                      className="btn btn-search"
                      onClick={() => {
                        setPage(1);
                        setRefresh((n) => n + 1);
                      }}
                    >
                      <img src={search1} className="search" alt="" />
                    </Button>
                    <button
                      type="button"
                      className="btn btn-reset"
                      onClick={() => {
                        setSearch("");
                        setEmployeeId("");
                        setPage(1);
                        setRefresh((n) => n + 1);
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>

                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="sr">Sr. No.</th>
                          <th className="tax-name">Employee ID</th>
                          <th className="tax-name">Name</th>
                          <th className="tax-name">Email</th>
                          <th className="tax-name">Contact</th>
                          <th className="tax-name">Status</th>
                          <th className="active">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((d, index) => (
                          <tr key={d.id}>
                            <td>{(page - 1) * PER_PAGE + index + 1}.</td>
                            <td>{d.employee_id || "-"}</td>
                            <td>{d.name}</td>
                            <td>{d.email}</td>
                            <td>{d.contact_no}</td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  checked={!!d.status}
                                  onChange={() => changeStatus(d.id)}
                                  id={`staffStatus${d.id}`}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`staffStatus${d.id}`}
                                >
                                  {d.status ? "Active" : "Inactive"}
                                </label>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex">
                                {isAllow.includes(IDS.User.Edit) && (
                                  <EditButton
                                    handleShow1={setEditId}
                                    id={d.id}
                                  />
                                )}
                                {isAllow.includes(IDS.User.Delete) && (
                                  <DeletButton
                                    showDeleteRecord={(id, name) =>
                                      setDeleteTarget({ id, name })
                                    }
                                    id={d.id}
                                    name={d.name}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {data.length > 0 ? (
                      <Pagination_Holder
                        onPageChange={page}
                        totalPages={totalPages}
                        handlePageChange={setPage}
                      />
                    ) : (
                      <p className="no-datashow">Sorry, No Data Found</p>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {showAdd && (
        <StaffForm
          role={role}
          editId={0}
          show={showAdd}
          handleClose={() => setShowAdd(false)}
        />
      )}
      {editId ? (
        <StaffForm
          role={role}
          editId={editId}
          show={!!editId}
          handleClose={() => setEditId(0)}
        />
      ) : null}

      <ModalDelete
        show={!!deleteTarget}
        handleDeleteRecord={confirmDelete}
        handleDeleteCancel={() => setDeleteTarget(null)}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default StaffTabs;
